<div
  class="nav-container"
  *ngIf="menuExpanded"
  [class.open]="menuExpanded | async"
  [class.collapsed]="!(menuExpanded | async)">
  <div class="tenant-selection" *ngIf="(dataShareService.availableTenants$ | async).length > 1">
    <mat-form-field appearance="outline">
      <mat-label>Mandant</mat-label>
      <input type="text" matInput [formControl]="tenantFilterControl" [matAutocomplete]="auto" />
      <mat-autocomplete
        #auto="matAutocomplete"
        [displayWith]="displayTenant"
        (optionSelected)="setTenant($event.option.value)">
        <mat-option *ngFor="let item of filteredTenants | async" [value]="item">
          {{ item.displayName }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <mat-action-list role="list" class="nav" [class.nav--moving]="moveMode">
    <!-- Favoriten: flache Liste favorisierter Blatt-Einträge, im Verschiebe-Modus per Drag & Drop sortierbar -->
    <div *ngIf="favorites.length" class="nav__favorites">
      <div class="nav__title nav__favorites-title" (mouseenter)="hideSubmenuGroups()">
        <mat-list-item [disableRipple]="true">
          <span class="nav__label">Favoriten</span>

          <span *ngIf="moveMode" class="nav__favorites-actions">
            <button mat-icon-button type="button" title="Reihenfolge speichern" (click)="finishMove()">
              <mat-icon>check</mat-icon>
            </button>
            <button mat-icon-button type="button" title="Abbrechen" (click)="cancelMove()">
              <mat-icon>close</mat-icon>
            </button>
          </span>
        </mat-list-item>
      </div>

      <div
        cdkDropList
        cdkDropListOrientation="vertical"
        cdkDropListLockAxis="y"
        [cdkDropListDisabled]="!moveMode"
        (cdkDropListDropped)="dropFavorite($event)">
        <div
          *ngFor="let node of displayedFavorites"
          cdkDrag
          cdkDragPreviewContainer="parent"
          [cdkDragStartDelay]="favoriteDragStartDelay"
          class="nav__link nav__favorite"
          [class.nav__link--active]="!moveMode && currentUrl.startsWith(node.link)"
          (mouseenter)="hideSubmenuGroups()"
          (contextmenu)="openFavoriteMenu($event, node, true)">
          <mat-list-item
            [matTooltip]="node.label"
            matTooltipPosition="right"
            [matTooltipDisabled]="!isCollapsed"
            [disableRipple]="moveMode"
            (click)="isSelected(node)">
            <span class="nav__icon-wrapper">
              <span class="nav__icon material-symbols-outlined notranslate">
                {{ moveMode ? 'drag_indicator' : node.icon || 'star' }}
              </span>
              <span
                *ngIf="node.iconBadge && !moveMode"
                class="nav__icon-badge material-symbols-outlined notranslate">
                {{ node.iconBadge }}
              </span>
            </span>

            <span class="nav__label">
              {{ node.label }}
            </span>
          </mat-list-item>
        </div>
      </div>
    </div>

    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
      <!-- Leaf nodes or titles -->
      <mat-tree-node
        *matTreeNodeDef="let node"
        matTreeNodeToggle
        [ngClass]="{
          nav__link: node.link,
          nav__title: node.isTitle,
          'nav__link--active': currentUrl.startsWith(node.link)
        }"
        (mouseenter)="mouseEnterNode($event)"
        (contextmenu)="openFavoriteMenu($event, node, false)">
        <mat-list-item
          [matTooltip]="node.label"
          matTooltipPosition="right"
          [matTooltipDisabled]="!isCollapsed || !node.icon"
          [disableRipple]="node.isTitle"
          (click)="isSelected(node)">
          <span *ngIf="node.icon" class="nav__icon-wrapper">
            <span class="nav__icon material-symbols-outlined notranslate">
              {{ node.icon }}
            </span>
            <span *ngIf="node.iconBadge" class="nav__icon-badge material-symbols-outlined notranslate">
              {{ node.iconBadge }}
            </span>
          </span>

          <span class="nav__label">
            {{ node.label }}
          </span>
        </mat-list-item>
      </mat-tree-node>

      <!-- Expandable nodes -->
      <mat-nested-tree-node
        *matTreeNodeDef="let node; when: hasChild"
        class="nav__link nav__expandable"
        (mouseenter)="mouseEnterNode($event)">
        <mat-list-item matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.label">
          <span *ngIf="node.icon" class="nav__icon material-symbols-outlined notranslate">
            {{ node.icon }}
          </span>

          <span class="nav__label">
            {{ node.label }}
          </span>

          <span class="nav__chevron material-symbols-outlined notranslate">
            {{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}
          </span>
        </mat-list-item>

        <div
          class="nav__group"
          [class.nav__group--collapsed]="!treeControl.isExpanded(node)"
          role="group"
          (mouseenter)="mouseEnterGroup($event)"
          (mouseleave)="mouseLeaveGroup($event)">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </mat-action-list>

  <!-- Unsichtbarer Anker an der Mausposition für das Favoriten-Menü (Rechtsklick) -->
  <div
    #favoriteMenuTrigger
    class="nav__favorite-menu-anchor"
    [style.left.px]="favoriteMenuPosition.x"
    [style.top.px]="favoriteMenuPosition.y"
    [matMenuTriggerFor]="favoriteMenu"></div>

  <mat-menu #favoriteMenu="matMenu">
    <ng-template matMenuContent let-node="node" let-canMove="canMove" let-isFavorite="isFavorite">
      <button *ngIf="!isFavorite" mat-menu-item type="button" (click)="addFavorite(node)">
        <mat-icon>star</mat-icon>
        <span>Zu Favoriten hinzufügen</span>
      </button>
      <button *ngIf="isFavorite" mat-menu-item type="button" (click)="removeFavorite(node)">
        <mat-icon>star_outline</mat-icon>
        <span>Favorit entfernen</span>
      </button>
      <button *ngIf="canMove" mat-menu-item type="button" (click)="startMove()">
        <mat-icon>swap_vert</mat-icon>
        <span>Verschieben</span>
      </button>
    </ng-template>
  </mat-menu>
</div>

<mat-list class="collapse-menu-button">
  <mat-list-item
    title="Seitenmenü umschalten"
    [class.open]="menuExpanded | async"
    [class.collapsed]="!(menuExpanded | async)"
    [class.btn_open]="menuExpanded | async"
    [class.btn_collapsed]="!(menuExpanded | async)"
    (click)="toggleMenu()">
    <span class="nav__icon material-symbols-outlined notranslate">
      {{ (menuExpanded | async) ? 'chevron_left' : 'chevron_right' }}
    </span>
    <span class="nav__label">Menü verkleinern</span>
  </mat-list-item>
</mat-list>
